// Car Content
import CarHero from 'assets/images/psp/hero/car-hero.webp';
import car10x15 from 'assets/images/icons/psp-car-storage-guide/10x15-car.svg';
import car10x20 from 'assets/images/icons/psp-car-storage-guide/10x20-car.svg';
import car10x25 from 'assets/images/icons/psp-car-storage-guide/10x25-car.svg';
import car10x30 from 'assets/images/icons/psp-car-storage-guide/10x30-car.svg';
import car10x35 from 'assets/images/icons/psp-car-storage-guide/10x35-car.svg';
import car10x40 from 'assets/images/icons/psp-car-storage-guide/10x40-car.svg';
import car10x50 from 'assets/images/icons/psp-car-storage-guide/10x50-car.svg';
import carContent1 from 'assets/images/psp/content/car-psp-rich-content-1.png';
import carContent2 from 'assets/images/psp/content/car-psp-rich-content-2.png';
import Car1 from 'assets/images/psp/FeaturedImages/car1.webp';
import Car2 from 'assets/images/psp/FeaturedImages/car2.webp';
import Car3 from 'assets/images/psp/FeaturedImages/car3.webp';
import Car4 from 'assets/images/psp/FeaturedImages/car4.webp';
const carRichContent1 =
	'The key to finding the right storage unit size for a car is taking accurate measurements ' +
	"and accounting for the extra space you'll need to maneuver and access your vehicle safely.\n\n" +
	"### Step 1: Measure Your Car's Dimensions\n\n" +
	"Start by measuring your car's **length**, **width**, and **height** using a tape measure:\n\n" +
	'- **Length:** Measure from the front bumper to the rear bumper at the longest points\n' +
	'- **Width:** Measure across the widest part, typically at the mirrors or wheel wells\n' +
	'- **Height:** Measure from the ground to the highest point, usually the roof or antenna\n\n' +
	"Don't forget to measure with the doors open if you plan to access your car while it's stored, " +
	'as this can add **2–3 feet** to each side.\n\n';

const carRichContent2 =
	'### Step 2: Add Buffer Space\n\n' +
	"Never choose a unit that exactly matches your car's dimensions. Add these minimum clearances:\n\n" +
	'- **Length:** Add 3-4 feet total (front and back) for safe maneuvering\n' +
	'- **Width:** Add 2-3 feet total (both sides) to open doors and walk around\n' +
	'- **Height:** Add 1-2 feet for clearance, especially for SUVs or trucks\n\n' +
	'**Pro Tip:** If your measurements put you between two sizes, always choose the larger unit size. ' +
	'The extra space makes storing and accessing your car much easier and safer.\n\n' +
	"Taking these measurements ensures you'll select a storage unit that protects your vehicle " +
	'while giving you the space you need to use it comfortably.\n\n';

const carRichContent3 =
	'Figuring out the right size storage unit to store your car in is the first step in finding the right car storage solution for you. Once you’ve gotten your car’s measurements and planned out your optimal vehicle storage space, you need to figure out what type of storage you need. Let’s take a look at premium indoor car storage and affordable outdoor car storage options to help make the best choice. \n\n' +
	'Self-storage facilities offer three main car storage options: \n\n' +
	'- **Outdoor car storage, uncovered** - Budget-friendly parking spaces that resemble traditional parking lots. \n\n' +
	'- **Outdoor car storage, covered** - Weather protection at mid-range pricing, best for short to mid-term auto storage. \n\n' +
	'- **Indoor enclosed car storage** - Indoor car storage units provide maximum security and climate control to give your car a cool, highly secure unit that’s ideal for long-term car storage. \n\n';
const reviews = [
	{
		reviewTitle: 'Easy to register and the first month is free',
		reviewRating: 5,
		reviewText:
			"Easy to register and first month was free. The unit is clean and easy to maneuver my classic car in and out. And it's climate-controlled!",
		reviewerInitials: 'CB',
		link: 'https://www.trustpilot.com/reviews/676941d937311529e3c8e617',
		reviewerName: 'customerBill',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'Super easy and relaxing experience!',
		reviewRating: 5,
		reviewText:
			"It was easy to find a location I needed, and once I sent my request, the gal called me that evening and was super friendly. I've been stressed about finding a place to store my car between visits, and this experience made it so easy, and now I can relax!",
		reviewerInitials: 'MP',
		link: 'https://www.trustpilot.com/users/5c9c3158bce74c6ce8c431c2',
		reviewerName: 'Marcia Pierce-rasmussen',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'Very helpful',
		reviewRating: 5,
		reviewText:
			'Very helpful. I needed a storage space for my car that had to be a drive-up and climate-controlled, and 10x20. Efficient searching and found exactly what I was looking for, and held it for me.',
		reviewerInitials: 'BD',
		link: 'https://www.trustpilot.com/reviews/633b51913d107cfdfcd20911',
		reviewerName: 'Blaine Dyson',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'Excellent Place to Look for Vehicle Storage',
		reviewRating: 5,
		reviewText:
			'This was a great place to look for local storage for my vehicle, which was a sports car for the summer. They were able to find me the closest and cheapest storage, which is not easy. They also provide terms and costs, so it was no surprise when I signed up.',
		reviewerInitials: 'DY',
		link: 'https://www.trustpilot.com/reviews/631b74886a3e1ed2c3ce9c14',
		reviewerName: 'David W. Young',
		reviewDate: 'January 3rd, 2023',
	},
];

const faqs = [
	{
		question: 'What information do I need to reserve a car storage unit?',
		answer:
			"To reserve car storage, you'll need a **valid driver's license**, **insurance information**, **vehicle registration**, and a **payment method**.\n\n" +
			'Some facilities may also require **vehicle dimensions** and **storage duration**.',
	},
	{
		question: 'Can I store a car in a storage unit?',
		answer:
			'Yes, you can store a car in a storage unit, but there are important requirements:\n\n' +
			'**Check First:** Not all storage facilities allow parked cars in their units. Always verify your facility permits vehicle storage.\n\n' +
			'**Requirements:**\n' +
			'- **Size:** Measure your car to ensure you’re choosing the right unit size for your vehicle.\n' +
			'- **Documentation:** You must have the vehicle registered under your name and bring registration plus proof of ownership.\n' +
			'- The car needs to be in running condition.\n\n' +
			'**Important:** Storage is for parking only — you cannot work on or repair your car in the unit due to safety regulations.\n\n' +
			'Most facilities that allow vehicles will accommodate car storage as long as you meet their specific requirements and choose an appropriately sized unit.',
	},
	{
		question: 'Can you work on a car in a storage unit?',
		answer:
			'Most storage facilities prohibit **vehicle maintenance and repairs** inside units due to **safety regulations** and **fire codes**.\n\n' +
			'Check facility policies before renting, as some allow **basic maintenance** in designated areas.',
	},
	{
		question: 'How often should I start my car in storage?',
		answer:
			'Start stored vehicles every **2–4 weeks** to maintain battery life and prevent engine issues.\n\n' +
			'Run the engine for **10–15 minutes**, with the unit door open, and move the car slightly to prevent **tire flat spots** during long-term car storage.',
	},
	{
		question: 'Can I get a car storage unit with electricity?',
		answer:
			'Many facilities offer car storage with **electrical outlets** for battery tenders and lighting.\n\n' +
			'**Climate-controlled** car storage units typically include electricity, though availability varies by location and may cost extra.',
	},
];

export const CarContent = {
	type: 'Car',
	sections: [
		{
			title: 'Car Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'rv-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Car Storage For You',
							description:
								'Not sure where to store a car for a month, week, or even a year? SpareFoot has you (and your automobile) covered. From the daily driver needing a little R&R, to the vintage beauty waiting to be restored, we’ll help you find the perfect car storage space to keep your ride ready for the open highway, the showroom, or wherever the road will take you next. ',
							image: CarHero,
							CTAText: 'Search & Reserve Instantly',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Car Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'Car Storage Size Comparison',
			noPaddingBottom: true,
			modules: [
				{
					title: 'RV Storage Content',
					type: 'content',
					props: {
						title: 'How to Find the Right Storage Unit Size for a Car',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'There are more ways and places to store a car near you than you think. Many self-storage facilities offer car storage units where you can rent vehicle storage in a variety of options. From uncovered parking spaces to fully enclosed, premium auto storage units, SpareFoot can find a home for every car. Not sure where to start? Our car storage size guide can help.',
						],
					},
				},
				{
					title: 'Vehicle Storage Units',
					type: 'unitList',
					id: 'vehicle storage unit cards',
					props: {
						slug: 'vehicle-storage-unit-cards',
						scrollFactor: 3,
						unitsData: [
							{
								image: car10x15,
								content:
									'### 10’ Wide x 15’ Long\n\n' +
									'- Most compact and two-door cars, like hatchbacks, crossovers, and small SUVs, come in at just around 15 feet in length. \n\n' +
									'- Always make sure to measure your car before renting out a storage unit, it must be under 15 feet in length to fit in a 10’x15’ unit. \n\n' +
									'- Because most cars fit into a 10’ wide unit, most car storage facilities will not note the width on their facility page.',
							},
							{
								image: car10x20,
								content:
									'### 10’ Wide x 20’ Long\n\n' +
									'- Most cars are less than 20 feet long and will fit comfortable inside a 10x20 car storage unit. \n\n' +
									'- This includes SUVs, crossovers, sedans, minivans, pickup trucks, and most full-sized vans. \n\n' +
									'- Because most cars fit into a 10’ wide unit, most car storage facilities will not note the width on their facility page.',
							},
							{
								image: car10x25,
								content:
									'### 10’ Wide x 25’ Long\n\n' +
									'- Perfect for larger vehicles or a boat. \n\n' +
									'- Small Class B campers, small Class C campers, travel trailers, toy trailers and pop-ups may also fit in spaces designed for RV storage.',
							},
							{
								image: car10x30,
								content:
									'### 10’ Wide x 30’ Long\n\n' +
									'- Very few vehicle models require a 10’x30’ storage unit, except for the largest trucks and vans. \n\n' +
									'- Storage units typically have a 8’ to 10’ tall ceiling, so if your truck is on larger wheels or on a lift kit, it may be too tall for some units. Always be sure to measure the height of larger cars. \n\n' +
									'- Because most cars fit into a 10’ wide unit, most car storage facilities will not note the width on their facility page.',
							},
							{
								image: car10x35,
								content:
									'### 10’ Wide x 35’ Long\n\n' +
									'- Store one or multiple vehicles with plenty of other possessions, including furniture and large appliances. \n\n' +
									'- This size can typically contain large Class B and Class C campers, mid-to-large sized travel trailers, small-to-mid sized fifth-wheel campers, large toy trailers, and small Class A campers.',
							},
							{
								image: car10x40,
								content:
									'### 10’ Wide x 40’ Long\n\n' +
									'- All but the largest of RVs will fit into a 40’ storage space. This includes most Class A campers, large travel trailers and fifth-wheel trailers. \n\n' +
									'- Remember that with the added length often comes additional width and height, meaning that many of these extra-large vehicles will require ceilings with a minimum height of 15 feet.',
							},
							{
								image: car10x50,
								content:
									'### 10’ Wide x 50’ Long\n\n' +
									'- 50’ RV storage space will handle the largest of RVs, like large Class A campers, travel trailers and destination trailers. \n\n' +
									'- Remember that with the added length often comes additional width and height, meaning that many of these extra-large vehicles will require ceilings with a minimum height of 15 feet.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Car Storage content',
			background: 'white',
			noPadding: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'What Size Storage Unit Do I Need for My Car?',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						content: [carRichContent1],
						contentImage: carContent1,
					},
				},
				{
					type: 'content',
					props: {
						title: '',
						contentType: 'row-type',
						ShowBackgroundImage: true,
						content: [carRichContent2],
						contentImage: carContent2,
					},
				},
			],
		},
		{
			title: 'What Type of Car Storage Do You Need?',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'What Type of Car Storage Do You Need?',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [carRichContent3],
					},
				},
				{
					type: 'videoSection',
					props: {
						theme: 'dark',
						src: 'https://www.youtube.com/embed/EVZF3Hs4FVU',
						slug: 'What Type of Car Storage Do You Need?',
					},
				},
			],
		},
		{
			title: 'Car Storage Average Price Table',
			modules: [
				{
					type: 'content',
					props: {
						title: 'How Much Does Car Storage Cost per Month?',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Car storage rates are usually charged monthly and vary based on:\n\n' +
								'- Unit size\n' +
								'- Location (urban vs. rural areas) and proximity to the city center\n' +
								'- Proximity to city center\n' +
								'- Auto storage type (indoor, outdoor, or covered outdoor)\n\n' +
								'**Car storage costs** increase with added features - fully enclosed units cost more than outdoor car storage. See average monthly prices for standard storage unit sizes below.\n',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Auto Storage Unit Size',
								key: 'Auto Storage Unit Size',
							},
							{
								label: 'Average Monthly Price',
								key: 'Average Monthly Price',
							},
						],
						rows: [
							{
								'Auto Storage Unit Size': "15' Long",
								'Average Monthly Price': '$79.56',
							},
							{
								'Auto Storage Unit Size': "20' Long",
								'Average Monthly Price': '$77.17',
							},
							{
								'Auto Storage Unit Size': "25' Long",
								'Average Monthly Price': '$80.04',
							},
							{
								'Auto Storage Unit Size': "30' Long",
								'Average Monthly Price': '$85.01',
							},
							{
								'Auto Storage Unit Size': "35' Long",
								'Average Monthly Price': '$94.44',
							},
							{
								'Auto Storage Unit Size': "40' Long",
								'Average Monthly Price': '$106.98',
							},
						],
					},
				},
			],
		},
		{
			title: 'Car Storage Average Price Table',
			noPaddingTop: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'Getting Your Car In and Out of Storage',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: ['How to Prepare Your Car for Storage'],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Preparation Step',
								key: 'Preparation Step',
							},
							{
								label: 'Description',
								key: 'Description',
							},
						],
						rows: [
							{
								'Preparation Step': {
									type: 'markdown',
									markdown:
										'**Change the oil, filter, brake fluid, and coolant**',
								},
								Description:
									'Topping off your car fluids is highly recommended as the first step in how to prepare a car for long-term storage.',
							},
							{
								'Preparation Step': {
									type: 'markdown',
									markdown:
										'**Fill up your gas tank and add a fuel stabilizer**',
								},
								Description:
									"Keep your engine safe with a full tank that won't degrade or oxidize while in storage.",
							},
							{
								'Preparation Step': {
									type: 'markdown',
									markdown: '**Power down properly**',
								},
								Description:
									"Disconnecting the car battery for storage will preserve the life of your car's battery. If your car storage unit has electricity, hook it up to a trickle charger for added protection.",
							},
							{
								'Preparation Step': {
									type: 'markdown',
									markdown: '**Prep your tires**',
								},
								Description:
									"Fill to the appropriate PSI indicated in the owner's manual and use jack stands to ensure wheel health.",
							},
							{
								'Preparation Step': {
									type: 'markdown',
									markdown:
										'**Remove your windshield wipers**',
								},
								Description:
									'This will prevent degradation of materials and save you from needing to purchase replacements right away. ',
							},
							{
								'Preparation Step': {
									type: 'markdown',
									markdown: '**Pest proof and protect**',
								},
								Description:
									'Seal windows, cover the exhaust pipe, and apply a car cover.',
							},
							{
								'Preparation Step': {
									type: 'markdown',
									markdown: '**Be brake savvy**',
								},
								Description:
									'Release your parking brake to prevent rust or sticking during long-term car storage. ',
							},
						],
					},
				},
			],
		},
		{
			title: 'How to Take Your Car Out of Storage',
			background: 'gray',
			modules: [
				{
					type: 'content',
					props: {
						title: 'How to Take Your Car Out of Storage',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Step',
								key: 'Step',
							},
						],
						rows: [
							{
								Step: {
									type: 'checkbox',
									label: 'Clean your car interior and dust as needed',
								},
							},
							{
								Step: {
									type: 'checkbox',
									label: 'Check fluid levels',
								},
							},
							{
								Step: {
									type: 'checkbox',
									label: 'Check for cracks in the rubber of your tires and windshield wipers',
								},
							},
							{
								Step: {
									type: 'checkbox',
									label: 'Check tire pressure',
								},
							},
							{
								Step: {
									type: 'checkbox',
									label: 'Reattach your battery',
								},
							},
							{
								Step: {
									type: 'checkbox',
									label: 'Allow the car to run for a few minutes in an open and/or well-ventilated area',
								},
							},
							{
								Step: {
									type: 'checkbox',
									label: 'Slowly take your car for a test drive',
								},
							},
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'Find the Best Car Storage with SpareFoot',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Car Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'Featured Content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						contentCards: [
							{
								title: 'How to Store It',
								date: '10/20/2025',
								image: Car1,
								content:
									'How to Pick the Right Size Storage Unit for Your Car',
								link: 'https://sparefoot.com/blog/car-storage-size-guide',
							},
							{
								title: 'General Storage Advice',
								date: '10/22/2025',
								image: Car2,
								content:
									'How to Properly Prepare Your Car For Storage',
								link: 'https://sparefoot.com/blog/dont-skip-these-7-tips-for-long-term-car-storage',
							},
							{
								title: 'General Storage Advice',
								date: '10/22/2025',
								image: Car3,
								content: 'How to Prepare Your Car for Winter',
								link: 'https://sparefoot.com/blog/how-to-prepare-your-car-for-winter',
							},
							{
								title: 'General Storage Advice',
								date: '9/26/025',
								image: Car4,
								content:
									'Proper Storage Tips for Vehicle Batteries',
								link: 'https://sparefoot.com/blog/proper-storage-tips-for-vehicle-batteries',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'Vehicle',
							'RV',
							'Boat',
							'Motorcycle',
							'ClimateControl',
							'24Hour',
							'DriveUp',
							'Electricity',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
